module.exports = __webpack_public_path__ + "media/ELLUS.e5850997.mp4";